import { render, staticRenderFns } from "./DashboardCreationChooser.vue?vue&type=template&id=edaa4364&scoped=true"
import script from "./DashboardCreationChooser.vue?vue&type=script&lang=js"
export * from "./DashboardCreationChooser.vue?vue&type=script&lang=js"
import style0 from "./DashboardCreationChooser.vue?vue&type=style&index=0&id=edaa4364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaa4364",
  null
  
)

export default component.exports